import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const t = localStorage.getItem("lush_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    const p = window.location.pathname;
    if (err.response?.status === 401 && !p.startsWith("/login") && !p.startsWith("/book")) {
      localStorage.removeItem("lush_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const api = {
  zones: () => client.get("/zones").then((r) => r.data),
  activities: () => client.get("/activities").then((r) => r.data),
  createActivity: (d) => client.post("/activities", d).then((r) => r.data),
  updateActivity: (id, d) => client.put(`/activities/${id}`, d).then((r) => r.data),
  deleteActivity: (id) => client.delete(`/activities/${id}`).then((r) => r.data),
  packages: () => client.get("/packages").then((r) => r.data),
  createPackage: (d) => client.post("/packages", d).then((r) => r.data),
  updatePackage: (id, d) => client.put(`/packages/${id}`, d).then((r) => r.data),
  deletePackage: (id) => client.delete(`/packages/${id}`).then((r) => r.data),
  groups: () => client.get("/groups").then((r) => r.data),
  group: (id) => client.get(`/groups/${id}`).then((r) => r.data),
  createGroup: (d) => client.post("/groups", d).then((r) => r.data),
  updateGroup: (id, d) => client.put(`/groups/${id}`, d).then((r) => r.data),
  deleteGroup: (id) => client.delete(`/groups/${id}`).then((r) => r.data),
  reservations: (start, end) =>
    client.get("/reservations", { params: { start, end } }).then((r) => r.data),
  createReservation: (d) => client.post("/reservations", d).then((r) => r.data),
  deleteReservation: (id) => client.delete(`/reservations/${id}`).then((r) => r.data),
  availability: (date) => client.get("/availability", { params: { date } }).then((r) => r.data),
  scheduled: (start, end) =>
    client.get("/scheduled-activities", { params: { start, end } }).then((r) => r.data),
  createScheduled: (d) => client.post("/scheduled-activities", d).then((r) => r.data),
  deleteScheduled: (id) => client.delete(`/scheduled-activities/${id}`).then((r) => r.data),
  availabilityRange: (start, end) =>
    client.get("/availability-range", { params: { start, end } }).then((r) => r.data),
  bookings: (group_id) => client.get("/bookings", { params: { group_id } }).then((r) => r.data),
  createBooking: (d) => client.post("/bookings", d).then((r) => r.data),
  deleteBooking: (id) => client.delete(`/bookings/${id}`).then((r) => r.data),
  createZone: (d) => client.post("/zones", d).then((r) => r.data),
  updateZone: (id, d) => client.put(`/zones/${id}`, d).then((r) => r.data),
  deleteZone: (id) => client.delete(`/zones/${id}`).then((r) => r.data),
  users: (role) => client.get("/users", { params: { role } }).then((r) => r.data),
  createUser: (d) => client.post("/users", d).then((r) => r.data),
  updateUser: (id, d) => client.put(`/users/${id}`, d).then((r) => r.data),
  deleteUser: (id) => client.delete(`/users/${id}`).then((r) => r.data),
  meals: () => client.get("/meals").then((r) => r.data),
  createMeal: (d) => client.post("/meals", d).then((r) => r.data),
  updateMeal: (id, d) => client.put(`/meals/${id}`, d).then((r) => r.data),
  deleteMeal: (id) => client.delete(`/meals/${id}`).then((r) => r.data),
  invoices: () => client.get("/invoices").then((r) => r.data),
  invoice: (id) => client.get(`/invoices/${id}`).then((r) => r.data),
  createInvoice: (d) => client.post("/invoices", d).then((r) => r.data),
  deleteInvoice: (id) => client.delete(`/invoices/${id}`).then((r) => r.data),
  categories: () => client.get("/categories").then((r) => r.data),
  createCategory: (d) => client.post("/categories", d).then((r) => r.data),
  updateCategory: (id, d) => client.put(`/categories/${id}`, d).then((r) => r.data),
  deleteCategory: (id) => client.delete(`/categories/${id}`).then((r) => r.data),
  menus: () => client.get("/menus").then((r) => r.data),
  createMenu: (d) => client.post("/menus", d).then((r) => r.data),
  updateMenu: (id, d) => client.put(`/menus/${id}`, d).then((r) => r.data),
  deleteMenu: (id) => client.delete(`/menus/${id}`).then((r) => r.data),
  dashboard: () => client.get("/dashboard").then((r) => r.data),
  publicBooking: (d) => client.post("/public/booking", d).then((r) => r.data),
  publicCalendar: (month) => client.get(`/public/calendar?month=${month}`).then((r) => r.data),
  contacts: (q, tag) => client.get("/contacts", { params: { q, tag } }).then((r) => r.data),
  contactCreate: (d) => client.post("/contacts", d).then((r) => r.data),
  contactImport: (d) => client.post("/contacts/import", d).then((r) => r.data),
  contactDelete: (id) => client.delete(`/contacts/${id}`).then((r) => r.data),
  contactToggleSub: (id) => client.patch(`/contacts/${id}/unsubscribe`).then((r) => r.data),
  uploadFile: (file) => { const fd = new FormData(); fd.append("file", file); return client.post("/uploads", fd).then((r) => r.data); },
  emailStatus: () => client.get("/email/status").then((r) => r.data),
  sendIndividual: (fd) => client.post("/email/send-individual", fd).then((r) => r.data),
  campaignAudience: (tag) => client.get(`/campaigns/audience?tag=${tag}`).then((r) => r.data),
  sendCampaign: (d) => client.post("/campaigns/send", d).then((r) => r.data),
  mailbox: () => client.get("/mailbox").then((r) => r.data),
  mailboxRead: (id) => client.patch(`/mailbox/${id}/read`).then((r) => r.data),
  mailboxSend: (group_id, template) => client.post("/mailbox/send", { group_id, template }).then((r) => r.data),
};

export const money = (n) =>
  "LKR " + (Number(n) || 0).toLocaleString("en-LK", { maximumFractionDigits: 0 });

const CAT_PALETTE = ["#1C3F35", "#CC5500", "#3B82F6", "#10B981", "#8B5CF6", "#F59E0B", "#14B8A6", "#A855F7"];
export const catColor = (name = "") =>
  CAT_PALETTE[[...name].reduce((a, c) => a + c.charCodeAt(0), 0) % CAT_PALETTE.length];

export const groupActivitiesByCategory = (items = [], activities = [], catOrder = {}) => {
  const catOf = (aid) => activities.find((a) => a.id === aid)?.category || "Other";
  const m = {};
  items.forEach((it) => { const c = catOf(it.activity_id); (m[c] = m[c] || []).push(it); });
  return Object.entries(m).sort((a, b) => (catOrder[a[0]] ?? 99) - (catOrder[b[0]] ?? 99));
};

export const STATUSES = ["Lead", "Contacted", "Proposal", "Confirmed", "Completed", "Lost"];

export const MEALS = [
  "Welcome Drink", "Morning Refreshments", "Breakfast", "Lunch",
  "Hi-Tea", "Evening Refreshments", "Dinner", "BBQ Dinner",
];

export const STATUS_COLORS = {
  Lead: "bg-stone-200 text-stone-700",
  Contacted: "bg-blue-100 text-blue-700",
  Proposal: "bg-amber-100 text-amber-800",
  Confirmed: "bg-emerald-100 text-emerald-800",
  Completed: "bg-forest text-white",
  Lost: "bg-red-100 text-red-700",
};
